module.exports = __webpack_public_path__ + "img/logo-medclub-empresa-app.f5a234c2.png";